import { Navigate, Routes, Route } from "react-router-dom";
import MonthClosure from "./components/MonthClosure";
import { Container } from "./styles";
import UserBills from "./components/UserBills";
import { Transactions } from "./components/Transactions";
import { useAuth } from "../../hooks/AuthContext";
import { useOnboard } from "../../hooks/OnboardContext";

interface FinancialProps {
  initialTab?: number;
}

export function Financial({ initialTab }: FinancialProps) {
  const { isFixiter: authIsFixiter, isLicenseeWithPrinter: authIsLicenseeWithPrinter } = useAuth();
  const { isFixiter: onboardIsFixiter, isLicenseeWithPrinter: onboardIsLicenseeWithPrinter } = useOnboard();
  const isLicenseeWithPrinter = onboardIsLicenseeWithPrinter || authIsLicenseeWithPrinter;
  const isFixiter = isLicenseeWithPrinter ? false : (onboardIsFixiter || authIsFixiter);

  if (isFixiter) {
    return <Navigate to="/dashboard" replace />;
  }

  if (initialTab !== undefined) {
     if (initialTab === 0) return <Container><MonthClosure /></Container>;
     if (initialTab === 1) return <Container><UserBills /></Container>;
     if (initialTab === 2) return <Container><Transactions /></Container>;
  }

  // Fallback se acessar apenas /financial, redireciona para reports (ou a que preferir)
  return <Navigate to="/financial/reports" replace />;
}
